import StickyContainer, { useStickyContext, StickyContextProvider } from './StickyContainer';

export { useStickyContext, StickyContextProvider };
export default StickyContainer;
